import React, { Suspense, useState, useEffect, useRef } from "react";
import { Modal } from 'react-responsive-modal';

export default function QueueMerge(param:any) {

    var [orderByFields, setOrderByFields] =  useState(1);

    const closeQueueMerge =(e:any) =>{
        if(e === "Close"){
            param.closeQueueMerge(false);
        }
        
        if(e === "Submit"){
            param.closeQueueMerge(orderByFields);
        }
    }
    return (       
        <Modal open={param.openQueueMerge} onClose={()=>closeQueueMerge("Close")} styles={{ modalContainer: { background: 'transparent !important' , maxWidth:"0% !important"} }} >  

            <div className="box noBorderRadius noBorder ws-12 pull-right">
                <div className="box-header-main">
                    <h2>Order Merge Files</h2>
                </div>

                <div className="box-content">

                    <div className="form-format ws-12">
                        <label>
                            <input type="radio" name="orderByFields" value="1" checked={orderByFields === 1} onClick={()=>{orderByFields = 1;setOrderByFields(1)}}/> By Contact Name, Contract Code 
                        </label>

                        <label>
                            <input type="radio" name="orderByFields" value="2" checked={orderByFields === 2} onClick={()=>{orderByFields = 2;setOrderByFields(2)}}/> By Contract Code 
                        </label>

                        <label>
                            <input type="radio" name="orderByFields" value="3" checked={orderByFields === 3} onClick={()=>{orderByFields = 3;setOrderByFields(3)}}/> By Main Contract Contact, Contract, Sub Contract
                        </label>
                        
                    </div>

                </div>

                <div className="box-footer">
                    <button className="icon-btn edit pull-right" onClick={()=>closeQueueMerge("Submit")}>  Submit </button>
                    <button className="icon-btn delete pull-right" onClick={()=>closeQueueMerge("Close")}>  Close </button>
                </div>
            </div>
        </Modal>        
    )
}